import { put, takeEvery } from 'redux-saga/effects';
import { USER_LOGIN_REQUEST } from '../constants/login.constants';
import { loginRequestFailure } from '../actions/account_actions/login.actions';
import { message_error } from '../../../../components/Message';
import api from '../../socket';

function* loginUserRequest({ authParams }) {
    const authRes = yield new Promise((resolve) => {
        api.init(authParams).then(resolve).catch(resolve);
    });

    if (authRes.result) {
        window.location.pathname = '/Leads/Manage';
    } else {
        yield put(loginRequestFailure(authRes));
        message_error(authRes);
    }
}

export default function* loginSaga() {
    yield takeEvery(USER_LOGIN_REQUEST, loginUserRequest);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/login.saga.js